import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';

const DelayedAdAssetsStep =
  () => import(/* webpackChunkName: "ad-assets-step.async" */ './ad-assets-step')
    .then(({ AdAssetsStepWithI18n }) => AdAssetsStepWithI18n);

const DelayedAdAssetsLazyRepository =
  () => import(/* webpackChunkName: "ad-assets-step.async" */ './ad-assets-lazy-repository')
    .then(({ AdAssetsLazyRepositoryWithI18n }) => AdAssetsLazyRepositoryWithI18n);

export const AdAssetsStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.AD_ASSETS,
  view: DelayedAdAssetsStep,
  repository: DelayedAdAssetsLazyRepository,
  viewProps: {
    isPmaxLiteSignup: true,
  },
  repositoryProps: {
    isPmaxLiteSignup: true,
  },
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
  },
};
